__turbopack_context__.v({
  "engagement": "-7Dk2G_engagement",
  "meta": "-7Dk2G_meta",
  "row": "-7Dk2G_row",
  "srOnly": "-7Dk2G_srOnly",
  "stat": "-7Dk2G_stat",
  "time": "-7Dk2G_time",
  "title": "-7Dk2G_title",
});
